export enum Groups {
    AssessmentUser = "9d0515bc-aa07-40e1-bfa8-6ca8b3af8e0c",
    AssessmentManager = "bd0579c8-c18d-46f4-b1a5-09c05cac0823"
}
